<script>
	import { nanoid } from "nanoid";

	export let id = nanoid(6);
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}

	</label>
{/if}
{#if !disabled}
	<input
		{id}
		class="form-control"
		type="text"
		{required}
		{disabled}
		{placeholder}
		{maxlength}
		bind:value
		on:change
	/>
{:else}
	<div class="form-control disabled-input">
		{value !== null ? value : ''}
	</div>
{/if}

<style>
	.disabled-input {
		height: auto !important;
		border-radius: 1px !important;
		font-size: 18px !important;
		line-height: 25px !important;
        padding: 10px 15px !important;
        margin: 0px auto !important;
		word-wrap: break-word !important;
		min-height: 44px !important;
	}
</style>

